module.exports = __webpack_public_path__ + "static/img/03_click.7b29b5ef.png";